export default {
	init: false,
	users: [],
	loggedInAs: null,
	user: null,
	external: null,
	datasource: null,
	subscriptions: null,
};
